// extracted by mini-css-extract-plugin
export default {"navbarLoader":"NavbarLoader_navbarLoader__cxbzY"};